import { render, staticRenderFns } from "./Configuration.vue?vue&type=template&id=6e9dae35&scoped=true&"
import script from "./Configuration.vue?vue&type=script&lang=js&"
export * from "./Configuration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e9dae35",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/tgs-automation/tgs-automation/mojaweb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6e9dae35')) {
      api.createRecord('6e9dae35', component.options)
    } else {
      api.reload('6e9dae35', component.options)
    }
    module.hot.accept("./Configuration.vue?vue&type=template&id=6e9dae35&scoped=true&", function () {
      api.rerender('6e9dae35', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/carbonclap/components/reporting/Configuration.vue"
export default component.exports